import React from 'react'

import { NotificationText, TextPart } from './styled'

interface Props {
  text: string
  highlightedWords: string[]
}
export const Highlighted: React.FC<Props> = ({ text, highlightedWords }) => {
  const textParts = text
    .split(new RegExp(`(${highlightedWords.join('|')})`, 'u'))
    .filter((part) => part.length > 0)

  return (
    <NotificationText>
      {textParts.map((part, itemArrayIndex) => (
        <TextPart
          key={itemArrayIndex}
          isHighlighted={highlightedWords.includes(part)}
        >
          {part}
        </TextPart>
      ))}
    </NotificationText>
  )
}
